import { render, staticRenderFns } from "./scrollDigital.vue?vue&type=template&id=302af91e&"
import script from "./scrollDigital.vue?vue&type=script&lang=js&"
export * from "./scrollDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/data/scrollDigital.vue"
export default component.exports